import * as THREE from 'three';
import { Base3DPart } from "./base-part";

export enum TelecameraPosition {
    BT = 'BACK_TOP',
    BB = 'BACK_BOTTOM',
    FT = 'FRONT_TOP',
    FB = 'FRONT_BOTTOM'
}

export class Telecamera3DPart extends Base3DPart {
    private position: number;
    private telecameraPosition?: TelecameraPosition;
    private offset: THREE.Vector3;
    private _type: string;

    constructor(cameraPosition: string, position: number, type: string) {
        let offset = new THREE.Vector3(0, position * 5, 0);
        if (type === 'Hyperion') {
            offset = new THREE.Vector3(0, position * 4.8, 0);
        } else if (type === 'Optica') {
            offset = new THREE.Vector3(0, position * 3.9, 0);
        }
        super(type, true);
        this.offset = offset;
        this.position = position;
        this._type = type;
        this.telecameraPosition = this.positionFromString(cameraPosition);
    }

    override load(scene: THREE.Scene): void {
        let path = '';
        switch (this.telecameraPosition) {
            case TelecameraPosition.BT:
                path = `${this.basePath}/telecamere/TC-back-top.gltf`;
                break;
            case TelecameraPosition.BB:
                path = `${this.basePath}/telecamere/TC-back-bottom.gltf`;
                break;
            case TelecameraPosition.FT:
                path = `${this.basePath}/telecamere/TC-front-top.gltf`;
                break;
            case TelecameraPosition.FB:
                path = `${this.basePath}/telecamere/TC-front-bottom.gltf`;
                break;
        }
        
        this.gltfLoader.load(path, (gltf) => {
            gltf.scene.position.add(this.offset);
            scene.add(gltf.scene);
        });
    }

    private positionFromString(position: string): TelecameraPosition {
        switch (position) {
            case 'SWIR re':
                return TelecameraPosition.BT;
            case 'RGBi re':
                return TelecameraPosition.BB;
            case 'SWIR fr':
                return TelecameraPosition.FT;
            case 'RGBi fr':
                return TelecameraPosition.FB;
            default:
                return TelecameraPosition.BT;
        }
    }
}